export default {
  sourceRatingImport: (state) => state.sourceRatingImport,
  isLoading: (state) => state.isLoading,
  hasError: (state) => !!state.error,
  error: (state) => state.error,
};
